import { PortraitState } from 'core/slices/player';
import { createSelector } from 'reselect';
import { RootState } from '../../../types';

const portrait = (state: RootState) => state.core.player.state.portrait;

export const selectPortrait = createSelector([portrait], portrait => {
  return portrait !== PortraitState.NOT_PORTRAIT;
});

export const selectPortraitState = (state: RootState) => state.core.player.state.portrait;
